// assets
import {
  IconHome,
  IconCalendarEvent,
  IconUsers,
  IconNotebook,
  IconBuildingCommunity,
  IconBed,
  IconFileInvoice,
  IconPhoneCheck,
  IconMessageReport,
  IconClipboardList,
  IconReportAnalytics,
  IconId,
  IconUserCog,
  IconChartArcs,
  IconBuildingHospital,
  IconTool,
  IconCurrencyRupee ,
  IconCheckbox,
  IconDeviceIpadUp,
  IconBell,
  IconSchool,
  IconBook2
} from '@tabler/icons-react';
import { Hospital, Fingerprint, Tags, Check, FolderUp, UtensilsCrossed } from 'lucide-react';

const MessageCircleMenuIcon = ({ stroke, size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={typeof stroke === 'number' ? stroke : 1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
    <path d="m8.9 11.9 1.9 1.9 4-4" />
  </svg>
);

const HospitalMenuIcon = ({ stroke, ...props }) => <Hospital {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;
const FingerprintPatternMenuIcon = ({ stroke, ...props }) => <Fingerprint {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;
const CategoryMenuIcon = ({ stroke, ...props }) => <Tags {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;
const FolderUpIcon = ({ stroke, ...props }) => <FolderUp {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;
const MessMenuIcon = ({ stroke, ...props }) => <UtensilsCrossed {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;

// import { IconUserCog,IconChartArcs3 } from '@tabler/icons-react';
// constant
const icons = {
  IconHome,
  IconCalendarEvent,
  IconUsers,
  IconNotebook,
  IconBuildingCommunity,
  IconBed,
  IconFileInvoice,
  IconPhoneCheck,
  IconMessageReport,
  IconClipboardList,
  IconReportAnalytics,
  IconId,
  IconUserCog,
  IconChartArcs,
  IconBuildingHospital,
  IconTool,
  IconCurrencyRupee,
  IconCheckbox,
  IconDeviceIpadUp,
  IconBell,
  IconSchool,
  IconBook2,
  MessageCircle: MessageCircleMenuIcon,
  Hospital: HospitalMenuIcon,
  FingerprintPattern: FingerprintPatternMenuIcon,
  Category: CategoryMenuIcon,
  FolderUp: FolderUpIcon,
  Mess: MessMenuIcon
};

// ==============================|| SUPER MOST ADMIN MENU ITEMS ||============================== //

const superMostAdmin = {
  type: 'SuperMostAdmin',
  children: [
    {
      id: 'sma-default',
      title: 'Dashboard',
      type: 'item',
      url: '/supermostadmin/default',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    {
      id: 'hostel',
      title: 'Hostel',
      type: 'collapse',
      icon: icons.IconBuildingCommunity,
      breadcrumbs: false,
      children: [
        {
          id: 'buildingmanagement',
          title: 'Building & Floor Management',
          type: 'item',
          url: '/supermostadmin/buildingmanagement',
          icon: icons.IconBuildingCommunity,
          breadcrumbs: false
        },
        {
          id: 'bookingRequest',
          title: 'Booking Request',
          type: 'item',
          url: '/supermostadmin/booking_request',
          icon: icons.IconCalendarEvent,
          breadcrumbs: false
        },
        {
          id: 'roomAllotment',
          title: 'Room Allotment',
          type: 'item',
          url: '/supermostadmin/roomallotment',
          icon: icons.IconBed,
          breadcrumbs: false
        },
        {
          id: '02',
          title: 'Room Allocation',
          type: 'item',
          url: '/supermostadmin/roomallocation',
          icon: icons.IconNotebook,
          breadcrumbs: false
        },
        {
          id: '03',
          title: 'Student Management',
          type: 'item',
          url: '/supermostadmin/studentmanagement',
          icon: icons.IconUsers,
          breadcrumbs: false
        },
        // {
        //   id: '90',
        //   title: 'Student Fee Management',
        //   type: 'item',
        //   url: '/supermostadmin/studentfeemanagement',
        //   icon: icons.IconCurrencyRupee ,
        //   breadcrumbs: false
        // },
        {
          id: '04',
          title: 'Hostel Attendance',
          type: 'item',
          url: '/supermostadmin/studentattendance',
          icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: '05',
          title: 'Complaint Management',
          type: 'item',
          url: '/supermostadmin/complaintmanagement',
          icon: icons.IconMessageReport,
          breadcrumbs: false
        },
        {
          id: 'superAdminGatePass',
          title: 'Superadmin Gate Pass',
          type: 'item',
          url: '/supermostadmin/superAdminGatePass',
          icon: icons.IconId,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'hospital',
      title: 'Hospital',
      type: 'collapse',
      url: '/supermostadmin/hospital_complaint',
      icon: icons.Hospital,
      breadcrumbs: false,
      children: [
        {
          id: '08',
          title: 'Hospital Complaint Management',
          type: 'item',
          url: '/supermostadmin/hospital_complaint',
          icon: icons.Hospital,
          breadcrumbs: false
        },
        {
          id: 'department',
          title: 'Department Management',
          type: 'item',
          url: '/supermostadmin/department',
          icon: icons.IconBuildingHospital,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'Fee',
      title: 'Fee Management',
      type: 'collapse',
      url: '/supermostadmin/Fee',
      icon: icons.IconCurrencyRupee,
      breadcrumbs: false,
      children: [
        {
          id: '90',
          title: 'Student Fee Management',
          type: 'item',
          url: '/supermostadmin/studentfeemanagement',
          icon: icons.IconCurrencyRupee ,
          breadcrumbs: false
        },
        {
          id: 'Fee Approval',
          title: 'Fee Approval',
          type: 'item',
          url: '/supermostadmin/FeeApproval',
          icon: icons.IconCheckbox ,
          breadcrumbs: false
        },
        {
          id: 'FeeReports',
          title: 'Fee Reports',
          type: 'item',
          url: '/supermostadmin/FeeReports',
          icon: icons.IconChartArcs,
          breadcrumbs: false
        },
        {
          id: 'feeupload',
          title: 'Fee Upload',
          type: 'item',
          url: '/supermostadmin/feeupload',
          icon: icons.FolderUp,
          breadcrumbs: false
        },
      ]
    },
    {
      id: 'tools',
      title: 'Tools',
      type: 'collapse',
      url: '/supermostadmin/roleManagement',
      icon: icons.IconTool,
      breadcrumbs: false,
      children: [
        {
          id: 'roleManagement',
          title: 'Admin Management',
          type: 'item',
          url: '/supermostadmin/roleManagement',
          icon: icons.IconUserCog,
          breadcrumbs: false
        },
         {
          id: 'ComplainCategoryManagement',
          title: 'Complaint Category Management',
          type: 'item',
          url: '/supermostadmin/ComplainCategoryManagement',
          icon: icons.Category,
          breadcrumbs: false
        },
        {
          id: 'auditLog',
          title: 'Audit Log',
          type: 'item',
          url: '/supermostadmin/auditLog',
          icon: icons.IconChartArcs,
          breadcrumbs: false
        },
        {
          id: 'devicePhotoUpload',
          title: 'Device Photo Upload',
          type: 'item',
          url: '/supermostadmin/DevicePhotoUpload',
          icon: icons.IconDeviceIpadUp,
          breadcrumbs: false
        },
          {
          id: 'deviceUploadManager',
          title: 'Device Upload Manager',
          type: 'item',
          url: '/supermostadmin/DeviceUploadManager',
          icon: icons.IconDeviceIpadUp,
          breadcrumbs: false
        },
         {
          id: 'ugDoorMgtSystem',
          title: 'UG Door Mgt System',
          type: 'item',
          url: '/supermostadmin/UgDoorMgtSystem',
          icon: icons.IconBell,
          breadcrumbs: false
        },
        {
          id: 'bioLog',
          title: 'Biometric Log',
          type: 'item',
          url: '/supermostadmin/biometricLog',
          icon: icons.FingerprintPattern,
          breadcrumbs: false
        },
        {
          id: 'whatsApp',
          title: 'WhatsApp Audit',
          type: 'item',
          url: '/supermostadmin/WhatsAppAudit',
          icon: icons.MessageCircle,
          breadcrumbs: false
        }
      ]
    },
      {
      id: '06',
      title: 'Reports',
      type: 'item',
      url: '/supermostadmin/reports',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
    // {
    //   id: 'courseManagement',
    //   title: 'Course Management',
    //   type: 'collapse',
    //   icon: icons.IconSchool,
    //   breadcrumbs: false,
    //   children: [
    //     {
    //       id: 'college',
    //       title: 'College',
    //       type: 'item',
    //       url: '/supermostadmin/college',
    //       icon: icons.IconBuildingCommunity,
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'course',
    //       title: 'Course',
    //       type: 'item',
    //       url: '/supermostadmin/course',
    //       icon: icons.IconBook2,
    //       breadcrumbs: false
    //     }
    //   ]
    // },
    {
      id: 'mess',
      title: 'Mess',
      type: 'collapse',
      icon: icons.Mess,
      breadcrumbs: false,
      children: [
        {
          id: 'messCard',
          title: 'Mess Card',
          type: 'item',
          url: '/supermostadmin/mess/card',
          icon: icons.IconId,
          breadcrumbs: false
        },
        {
          id: 'messStaff',
          title: 'Mess Staff',
          type: 'item',
          url: '/supermostadmin/mess/staff',
          icon: icons.IconUsers,
          breadcrumbs: false
        },
        {
          id: 'messStudentStaff',
          title: 'Mess Student/Staff',
          type: 'item',
          url: '/supermostadmin/mess/student-staff-report',
          icon: icons.IconFileInvoice,
          breadcrumbs: false
        },
        {
          id: 'messReports',
          title: 'Mess Reports',
          type: 'item',
          url: '/supermostadmin/mess/reports',
          icon: icons.IconClipboardList,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default superMostAdmin;
